import * as TK from 'components/BusinessGifting/ContactDialog/translations/constants';

export const eventInfoDialogCommonLocale = {
  [TK.CONTENT]:
    'Complete the info below and a member of our team will be in touch in the next 24 hours.  If you have any questions, don’t hesitate to contact us directly at ',
  [TK.BUSINESS_GIFTING_EMAIL]: 'sales@edible.com',
  [TK.TITLE]: 'Contact Your Gifting Concierge',
  [TK.EMAIL_LABEL]: 'Email Address*',
  [TK.SUBMIT]: 'Submit your inquiry',
  [TK.CANCEL]: 'Cancel',
  [TK.SUCCESS_CONTENT]:
    'Your request has been successfully submitted. A member of our Gifting Concierge team will review your details and reach out within the next 24 hours to assist you. If your request is urgent, please call us directly at',
  [TK.SUCCESS_TITLE]: 'Thank You For Your Inquiry!',
  [TK.EMAIL_VALID_ERROR]: 'Please enter a valid email address.',
  [TK.EMAIL_REQUIRED_ERROR]: 'Please enter your email address.',
  [TK.NAME_LABEL]: 'Name (Optional)',
  [TK.MESSAGE_LABEL]: 'Message (optional)',
  [TK.MESSAGE_PLACEHOLDER]: 'Enter any additional details or questions',
  [TK.ERROR_TRY_AGAIN]: 'Try again',
  [TK.ERROR_CONTENT]:
    'There seems to be an issue. Please try again or give us a call at ',
  [TK.ERROR_TITLE]: 'Sorry ):',
  [TK.FIRST_NAME_LABEL]: 'First Name*',
  [TK.LAST_NAME_LABEL]: 'Last Name*',
  [TK.PHONE_NUMBER_LABEL]: 'Phone Number*',
  [TK.COMPANY_NAME_LABEL]: 'Company Name*',
  [TK.QUANTITY_LABEL]: 'Quantity Needed?*',
  [TK.OCCASION_LABEL]: 'What’s the occasion?*',
  [TK.PRODUCTS_LABEL]: 'Products you are interested in*',
  [TK.CALL_US_DIRECTLY]: 'or call Us directly at',
  [TK.CALL_US_NUMBER]: '470-947-8967',
  [TK.FIRST_NAME_REQUIRED_ERROR]: 'Please enter your first name.',
  [TK.FIRST_NAME_VALID_ERROR]: 'Please enter a valid first name.',
  [TK.LAST_NAME_REQUIRED_ERROR]: 'Please enter your last name.',
  [TK.LAST_NAME_VALID_ERROR]: 'Please enter a valid last name.',
  [TK.PHONE_NUMBER_REQUIRED_ERROR]: 'Please enter your phone number.',
  [TK.PHONE_NUMBER_VALID_ERROR]: 'Please enter a valid phone number.',
  [TK.COMPANY_NAME_REQUIRED_ERROR]: 'Please enter your company name.',
  [TK.COMPANY_NAME_VALID_ERROR]: 'Please enter a valid company name.',
  [TK.QUANTITY_REQUIRED_ERROR]: 'Please enter the quantity needed.',
  [TK.QUANTITY_VALID_ERROR]: 'Please enter the valid quantity number.',
  [TK.QUANTITY_MIN_ERROR]: 'Please enter a quantity greater than 0.',
  [TK.OCCASION_REQUIRED_ERROR]: 'Please enter the occasion.',
  [TK.OCCASION_VALID_ERROR]: 'Please enter the valid occasion.',
  [TK.PRODUCTS_VALID_ERROR]: 'Please select at least one product.',
  [TK.CANT_BEGIN_WITH_O_OR_1]:
    "Phone Number can't begin with '0' or '1'. Please provide a 10-digit phone number, starting with the area code.",
  [TK.PLEASE_CHOOSE]: 'Please Choose',
};
